import { render } from "./TheSheetMenuIndex.vue?vue&type=template&id=84ed93c8&scoped=true"
import script from "./TheSheetMenuIndex.vue?vue&type=script&lang=js"
export * from "./TheSheetMenuIndex.vue?vue&type=script&lang=js"

import "./TheSheetMenuIndex.vue?vue&type=style&index=0&id=84ed93c8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-84ed93c8"

export default script